export enum FormType{
    GEF,
    AFG,
    BTB,
    VPB,
    SZF,
    FQA
}